<template>
  <div class="pageTosellout">
    <XR-head titleText="即将抢光"></XR-head>
    <div v-if="!hasData" class="activity-hours">
      <div class="desc">            
        库存紧张，抓住机会，速速下手！
      </div>
    </div>

    <div class="activity-main">
      <div class="activity-products" data="9" style="display: block;">
        <div class="product  " v-for="productItem in toBeSellOutList" :key="productItem.SkuId">
          <img :src="productItem.ImgPath?productItem.ImgPath:IMGServer_URL+'/images/index-item-default.png'" class="discount-pro-img">
          <div class="info" :style="{width:fullProductInfoWidth+'px'}">
            <p class="name">{{productItem.ProductName}}</p>
            <span class="desc">{{productItem.SellerPointer}}</span>
            <div class="row">
              <p class="price">
                <span class="discount-price">￥{{productItem.DiscountPrice}}</span>
                <span cass="red">元</span>
              </p>              
              <div class="btn">
                <router-link :to="'/retail/productDetail?skuId='+productItem.SkuId"><mu-raised-button secondary class="btn-text" style="width:75px">去秒杀</mu-raised-button></router-link>
              </div>
            </div>
            <div class="row">
              <span class="delete-price">￥{{productItem.Price}}元</span>
              <div class="stockProcess">                
                <span class="text" v-if="productItem.Stock>0">抢购中</span>
                <mu-linear-progress mode="determinate" class="process" style="width:75px" :value="productItem.BuyCount/productItem.Stock*100"/>
              </div>
            </div>
          </div>
        </div>
        <mu-divider></mu-divider>
      </div>
    </div>
    <template v-if="hasData">
        <div class="s_null" id="sNull01">
          <img style="width:30%;" src=" ../static/refresh/nomore.png" alt=""> 
          <p class="tip">亲，暂无更多产品！</p>
      </div>
    </template>
       <div class="xr-bottom">        
        <mu-paper class="bottom-nav">
          <mu-bottom-nav :value="bottomNav" shift @change="handleChange">
            <mu-bottom-nav-item to="/active/discount" value="index" title="限时抢购" icon=":fa fa-myshizhong4"/>
            <mu-bottom-nav-item to="/active/tosellout" value="category" title="即将抢光" icon=":fa fa-myshizhong3"/>
            <mu-bottom-nav-item to="/active/tomorrow" value="discount" title="明日预告" icon=":fa fa-myshizhong2"/>
            <mu-bottom-nav-item to="/usercenter/index" value="bugcart" title="商城首页" icon=":fa fa-liangren"/>
          </mu-bottom-nav>
        </mu-paper>
      </div>
</div>
</template>

<script>
export default {
  data(){
    return {
      fullProductInfoWidth: document.documentElement.clientWidth-115,
      fullProcessWidth : document.documentElement.clientWidth-115-80-50,
      toBeSellOutList:[],
      bottomNav: "",
      bottomNavColor: "",
      hasData:false
    }
  },
  mounted () {
    var path = this.$route.path
    if(path == '/active/discount'){
      this.bottomNav = 'index'
    }else if(path=='/active/tosellout'){
      this.bottomNav= 'category'
    }else if(path=='/active/tomorrow'){
      this.bottomNav= 'discount'
    }
    this.getToBeSellOutPage()
    this.hasDataShow()
  },
  methods:{    
    getToBeSellOutPage(){
      const ths = this;
      this.$post("/Shop/RetailServer/GetActivityDiscountToBeSellOutProducts")
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false
          ths.toBeSellOutList = res.Data
          ths.$refs.XRtoast.hide()
         
        }
        
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    hasDataShow(){
      if(this.toBeSellOutList.length==0){
        this.hasData = true
      }
      else{
        this.hasData = false
      }
    },
    handleChange(val) {
        this.bottomNav = val;
        if (this.bottomNav == "优惠") {
          this.$router.push("/usercenter/coin");
        }
      },
  }
}

</script>

<style>
#app .pageTosellout{
  padding-bottom: 70px;
  bottom:unset;
}
.pageTosellout .tabIcon.select{ color:red;}
.pageTosellout .tabTitle.select{ color:red;}

.pageTosellout .activity-hours { width:100%; }
.pageTosellout .activity-hours .desc { line-height:52px; text-align:center; color:#666;}

.pageTosellout  .activity-countdown { width:100%; }
.pageTosellout  .activity-countdown .countdown { width:195px; margin:0 auto; height:65px; padding:21px 0;}
.pageTosellout  .activity-countdown .countdown span { float:left; height:23px; line-height:23px; color:#666;}
.pageTosellout  .activity-countdown .countdown .desc { margin-right:5px;}
.pageTosellout  .activity-countdown .countdown .font { font-size:12px; width:14px; text-align:center; color:#666;}
.pageTosellout  .activity-countdown .countdown .time { font-size:18px; width:14px; height:23px; text-align:center; background:url(/static/active/countdown.png) no-repeat; color:white;}

.pageTosellout  .activity-products { width:100%; overflow:hidden; background:white;}
.pageTosellout  .activity-products .product { width:100%; overflow:hidden; padding:20px 10px; position:relative;}
.pageTosellout  .activity-products .product .discount-pro-img { width:85px; float:left; display: block;}
.pageTosellout  .activity-products .product .info { float:right; overflow:hidden;}
.pageTosellout  .activity-products .product .info .name { height:24px; line-height:24px; color:black; font-size:14px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;}
.pageTosellout  .activity-products .product .info .desc { display:block; height:15px; line-height:15px; overflow:hidden; font-size:12px; color:#666; margin-bottom: 10px;}
.pageTosellout  .activity-products .product .info .row {}
.pageTosellout  .activity-products .product .info .row .price { overflow:hidden; height:20px; line-height:20px;}
.pageTosellout  .activity-products .product .info .row .price .discount-price { font-size:20px; color:Red;}
.pageTosellout  .activity-products .product .info .row .price .red { color:Red; font-size:12px;}
.pageTosellout  .activity-products .product .info .row .btn {  cursor:pointer; overflow: hidden;}
.pageTosellout  .activity-products .product .info .row .btn .btn-text { font-size: 12px; float:right;  height:24px; line-height:24px; text-align:center; padding:0 5px;}
.pageTosellout  .activity-products .product .info .row .btn .btn-text.unable {border:1px solid #ccc;}
.pageTosellout .xr-bottom{position: fixed;bottom: 0;width: 100%;}
.pageTosellout .xr-bottom .bottom-nav .mu-bottom-item-icon{font-size: 26px;width: 30px;}
.pageTosellout  .activity-products .product .info .row .delete-price { float: left; width:80px; font-size:12px; line-height: 24px; color:#999; text-decoration:line-through;}
.pageTosellout  .activity-products .product .info .row .stockProcess{ float: left;}
.pageTosellout  .activity-products .product .info .row .stockProcess .process{ float: left; margin: 9px 0;}
.pageTosellout  .activity-products .product .info .row .stockProcess .text{ width: 50px; float: left; text-align: right; line-height: 24px; font-size: 12px;}

.pageTosellout .activity-nav-fix { position:fixed; height:70px; width:100%; bottom:0; background:#EEEEEE; border-top:2px solid #D7D8D8;}
.pageTosellout .activity-nav-fix .nav { width:25%; height:64px; float:left; padding:13px 0 0;}
.pageTosellout .activity-nav-fix .nav img { width:27px; display:block; margin:0 auto;}
.pageTosellout .activity-nav-fix .nav .text { line-height:18px; height:18px; margin-top:4px; margin-bottom:8px; display:block; text-align:center;color:#8b8d8c;}
.pageTosellout .activity-nav-fix .nav.active .text { color:Red;}

.pageTosellout .yingxiao.youpin .pro-list .item .price .del { line-height:32px;}
.pageTosellout #sNull01{
  text-align: center;
  padding-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/active/tosellout.vue